import styled from 'styled-components';
import { DialogActions } from '@material-ui/core';

const ModalPage = styled.div`
  width: 1100px;
  height: 85vh;
  overflow: hidden;
  .dialog-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  hr {
    background: #cacfd3;
    margin: 0;
  }
  .MuiDialogContent-root {
    padding: 0;
    &:first-child {
      padding-top: 0;
    }
  }
  .test-header {
    padding: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #192637;
    border-bottom: 1px solid rgb(202, 207, 211);
  }
  .test-body {
    padding: 20px;
    flex: 1;
    overflow-y: scroll;
  }
  .delete-icon {
    padding: 0;
  }
`;

export const ModalFooter = styled(DialogActions)`
  border-top: 1px solid rgb(202, 207, 211);
  padding: 10px 0px;
`;

export default ModalPage;
